export default {
  API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT || 'http://localhost:8080/api'
};